import { render, staticRenderFns } from "./RecentMediaWindow.vue?vue&type=template&id=007ed9ed&"
import script from "./RecentMediaWindow.vue?vue&type=script&lang=js&"
export * from "./RecentMediaWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports